import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  margin-top: 32px;

  ${mediaQueries.tablet} {
    margin-top: 48px;
  }
`
